import { ThemedInputType } from "./props";

/**
 * Default placeholder mappings for different input types
 */
export const placeholderMappings: Partial<Record<ThemedInputType, string>> = {
  integer: "123",
  float: "123.45",
  currency: "$123.45",
  date: "01/01/2001",
  "date-time": "01/01/2001 12:00 PM",
  "time-format": "12hr/24hr",
  "date-format": "YYYY-MM-DD",
};

/**
 * Input validation patterns for different input types
 */
export const inputPatterns: Partial<Record<ThemedInputType, RegExp>> = {
  integer: /^-?\d*$/,
  float: /^-?\d*\.?\d*$/,
  currency: /^-?\$?\d*\.?\d{0,2}$/,
  date: /^\d{0,2}([-/]?\d{0,2}([-/]?\d{0,4})?)?$/,
  "date-time": /^\d{0,2}([-/]?\d{0,2}([-/]?\d{0,4}(\s+\d{0,2}(:\d{0,2}(\s*([APap]?[Mm]?))?)?)?)?)?$/,
  text: /^\.*/,
  // time: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/, // HH:mm
  "date-format": /^(MM|DD|YYYY|yy|...)+$/, // flexible placeholder
};
